import { createListOptions, createSelectWithPlaceholder, toggleListOnClick } from './setInput';

export const setNewAccessorySelect = ({
  fieldID,
  options,
  preselectedOption,
  selectEl,
  onChange,
}) => {
  const formSelectEl = document.createElement('div');
  const ul = document.createElement('ul');
  const placeholder = document.createElement('span');

  toggleListOnClick({ selectEl });
  createSelectWithPlaceholder({
    fieldID,
    formSelectEl,
    placeholder,
    preselectedOption,
    selectEl,
    type: 'NewAccessory',
    ul,
  });
  createListOptions({ options, ul, selectEl, onChange });
};

export const setAccessoriesInitialSection = ({
  field,
  id,
  options,
  sectionContainer,
  setValidationOnField,
  setDependencyOnField,
  setValidationStateBasedOnVisibility,
  that,
}) => {
  const inputsContainer = document.createElement('div');
  inputsContainer.id = `${id}-container`;
  sectionContainer.appendChild(inputsContainer);

  createNewAccessoryInput({
    field,
    id,
    options,
    sectionContainer: inputsContainer,
    setValidationOnField,
    setDependencyOnField,
    setValidationStateBasedOnVisibility,
    that,
  });
};

const imageCache = {};
const getImageUrlAsync = ({ accessory }) => {
  if (imageCache[accessory.ItemNo] !== undefined) {
    // we already have image, no need to try again
    /* eslint-disable-next-line */
    return new Promise((resolve, reject) => {
      resolve(imageCache[accessory.ItemNo]);
    });
  }

  if (accessory.Color && accessory.ModelNo) {
    // try to load image from PIM
    return (
      fetch(
        `${window.location.origin}/api/pim/getColorImageAssets/${accessory.ModelNo}?filetype=psd&color=${accessory.Color}&primary=true`,
        {
          method: 'GET',
          headers: { 'Content-type': 'application/json' },
        },
      )
        .then(function (response) {
          if (!response.ok) {
            throw Error(response.statusText);
          }
          return response.json();
        })
        .then((data) => {
          if (data.length > 0) {
            const primaryImage = data[0]?.ThumbnailUrls['thumbnail100'] || data[0]?.Path;
            imageCache[accessory.ItemNo] = primaryImage;
            return primaryImage;
          } else {
            return returnDefault();
          }
        })
        /* eslint-disable-next-line */
        .catch((error) => {
          return returnDefault();
        })
    );
  } else {
    return returnDefault();
  }

  function returnDefault() {
    imageCache[accessory.ItemNo] = accessory.ImageUrl;
    /* eslint-disable-next-line */
    return new Promise((resolve, reject) => {
      resolve(imageCache[accessory.ItemNo]);
    });
  }
};

const createNewAccessoryInput = ({
  field,
  id,
  options,
  sectionContainer,
  setValidationOnField,
  setDependencyOnField,
  setValidationStateBasedOnVisibility,
  that,
}) => {
  const container = document.createElement('div');
  const imgContainer = document.createElement('div');
  const img = document.createElement('img');
  const selectEl = document.createElement('div');
  const fieldID = field.Id;
  const preselectedOption =
    field.SelectedItem !== null && that.configurationMode == 'edit'
      ? options?.find((o) => o.ItemNo === field.SelectedItem)
      : null;

  container.classList.add('configurator__section__fields__subsection', 'newAccessory');
  container.id = id;
  imgContainer.classList.add('newImg');

  var defaultAccessory = preselectedOption || options?.[0];
  if (defaultAccessory) {
    getImageUrlAsync({ accessory: defaultAccessory }).then((result) => {
      if (result) {
        img.src = result;
      }
    });
  }
  let onChange = (optionSelected) => {
    getImageUrlAsync({ accessory: optionSelected }).then((result) => {
      if (result) {
        img.src = result;
      }
    });
  };

  setNewAccessorySelect({ fieldID, options, preselectedOption, selectEl, onChange });

  imgContainer.appendChild(img);

  container.appendChild(imgContainer);
  container.appendChild(selectEl);
  sectionContainer.appendChild(container);

  const inputs = [];
  container.setAttribute('data-fieldid', field.Id);
  container.setAttribute(
    'value',
    selectEl.querySelector('.form-select__placeholder').getAttribute('data-option-value'),
  );
  inputs.push(container);

  const validationMessage = document.createElement('div');
  validationMessage.classList.add('configurator__validation-msg');
  validationMessage.style.display = 'none';
  container.appendChild(validationMessage);

  setValidationOnField({
    field,
    htmlInput: selectEl,
    htmlContainer: container,
    htmlValidationMessage: validationMessage,
    validateOnEvent: 'click',
    validateFunction: () => {
      let isValid = false;
      if (selectEl.getAttribute('value')) {
        isValid = true;
      } else {
        document.getElementById('warranty-submit').classList.add('is-disabled');
      }
      return isValid;
    },
    that,
  });

  // call this, because i am async to make the button work correctly
  that.recheckValidationOnConfigurator();

  setDependencyOnField({
    field,
    htmlInput: selectEl,
    controlToHide: container,
    triggerOnEvent: 'click',
    getValueCallback: (currentField) => currentField.inputs[0].value,
    onVisiblityChange: (currentField, hidden) =>
      setValidationStateBasedOnVisibility(currentField, hidden),
    that,
  });

  field.inputs = [selectEl];
};

export const getAccessoriesByType = async ({ accessoryType, modelNo }) => {
  return fetch(`/api/accessories/${modelNo}/${accessoryType}`, {
    method: 'GET',
    headers: { 'Content-type': 'application/json' },
  })
    .then((response) => response.json())
    .then((data) => {
      return data || null;
    });
};
